
   <div class="flex-grow-1 d-flex">
    <ds-icon
      [name]="iconPrefix + '-icon-error-outlined'"
      class="mr-8"
      [color]="'error'">
    </ds-icon>
    <div>
        <p class="text-body">
      <span>
        <div>
          <b>{{ 'passkey.profile.failed' | translate }}</b>
        </div>
      </span>
      </p>
    </div>
  </div>

   <div class="text-body-lg mb-10 mt-10">
     <p>{{ 'passkey.profile.failedDesc' | translate }}</p>
   </div>

   <button type="submit"
    ds-button
    class="w-100 mt-12"
    (click)="onCloseClick()"
    title="Close"><span>{{ 'passkey.profile.close' | translate }}</span>
  </button>